import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
// Modules
import app from './modules/app'
import answers from './modules/answers'
import userdata from './modules/userdata'

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist()

export default new Vuex.Store({
    plugins: [
        vuexLocalStorage.plugin
    ],
    modules: {
        app,
        answers,
        userdata
    }
})
